export var ru = {
  buttons: {
    save: {
      value: 'Сохранить',
      description: 'Кнопка для окон и экранов создания или редактирования сущности.'
    },
    confirm: {
      value: 'Подтвердить',
      description: 'Кнопка для окон и экранов, которые о чем-либо предупреждают пользователя. Например, при изменении настроек.'
    },
    create: {
      value: 'Создать',
      description: 'Кнопка для окон и экранов создания сущности.'
    },
    restore: {
      value: 'Восстановить',
      description: 'Кнопка для окон и экранов восстановления из резервной копии.'
    },
    change: {
      value: 'Изменить',
      description: 'Кнопка для подтверждения изменения сущности сервиса. Например, изменения параметров контейнера.'
    },
    edit: {
      value: 'Редактировать',
      description: 'Кнопка для окон и экранов редактирования сущности.'
    },
    done: {
      value: 'Готово',
      description: 'Кнопка для окон и экранов создания или редактирования сущности'
    },
    iSee: {
      value: 'Понятно',
      description: 'Кнопка для окон и экранов, которые о чем-либо информируют пользователя. Например, в сценариях онбординга.'
    },
    finish: {
      value: 'Завершить',
      description: 'Кнопка для окон и экранов, которые о чем-либо информируют пользователя. Например, для финального окна в онбординге.'
    },
    back: {
      value: 'Назад',
      description: 'Кнопка навигации для экранов создания или редактирования сущности с пошаговым сценарием. Используется в паре с кнопкой continue.'
    },
    next: {
      value: 'Далее',
      description: 'Кнопка навигации для сценариев, когда пользователь выполняет несложные пошаговые операции — например, с чем-то знакомится в онбординге или заполняет форму, чтобы связаться с менеджером.'
    },
    "continue": {
      value: 'Продолжить',
      description: 'Кнопка навигации для экранов создания или редактирования сущности с пошаговым сценарием. Используется в паре с кнопкой back.'
    },
    cancel: {
      value: 'Отмена',
      description: 'Кнопка для окон и экранов создания и редактирования чего-либо.'
    },
    send: {
      value: 'Отправить',
      description: 'Кнопка для отправки заявок и других данных.'
    },
    clearFilters: {
      value: 'Сбросить все фильтры',
      description: 'Кнопка сброса всех выбранных ранее фильтров.'
    },
    rent: {
      value: 'Арендовать',
      description: 'Evolution: BareMetal, Публичные IP. Кнопка для подтверждения аренды ресурсов.'
    }
  },
  tableColumns: {
    name: {
      value: 'Название',
      description: 'Колонка "Название" в табличных представлениях. В колонке группируются названия сущностей сервиса.'
    },
    status: {
      value: 'Статус',
      description: 'Колонка "Статус" в табличных представлениях. Статус — фаза жизненного цикла, в которой находится в текущий момент ресурс/сущность/задача. Например: Создан, Приостановлен, Удаляется и др. '
    },
    state: {
      value: 'Состояние',
      description: 'Колонка "Состояние" в табличных представлениях. Это поле используется редко, в основном, в продукте Managed Kubernetes.'
    },
    dateCreation: {
      value: 'Дата создания',
      description: 'Колонка "Дата создания" в табличных представлениях. В колонке указывается дата и опционально время создания сущности/задачи.'
    },
    dateStart: {
      value: 'Дата начала',
      description: 'Колонка "Дата начала" в табличных представлениях используется в паре с колонкой dateEnd. Указывает на начало процесса, например, дата начала резервного копирования.'
    },
    dateEnd: {
      value: 'Дата завершения',
      description: 'Колонка "Дата завершения" в табличных представлениях используется в паре с колонкой dateStart. Указывает на завершение процесса, например, дата завершения резервного копирования.'
    }
  },
  tableOptions: {
    rowsVolume: {
      value: 'Количество строк:',
      description: 'Кнопка для выбора количества строк в таблице. При нажатии кнопки появляется дропдаун с доступными значениями.'
    }
  },
  validation: {
    required: {
      value: 'Обязательное поле',
      description: ''
    },
    unique: {
      value: 'Название уже существует, попробуйте другое',
      description: ''
    }
  },
  textLabel: {
    creator: {
      value: 'Создатель',
      description: 'Везде, где указывается ФИО, логин, или email пользователя, который создал какую-либо сущность в сервисе.'
    }
  },
  placeholders: {
    searchName: {
      value: 'Поиск по названию',
      description: 'Подсказываем пользователю, что можно искать на странице по названию объектов.'
    }
  },
  tooltip: {
    noAccess: {
      value: 'Недоступно для вашей роли',
      description: 'Для выполнения действия у пользователя не хватает прав.'
    }
  },
  serverError: {
    textTitle: {
      value: 'Сервер не отвечает',
      description: 'На нашем бэкенде ошибка  503, сервер не отвечает и мы про это знаем.'
    },
    text: {
      value: 'Попробуйте повторить позже',
      description: 'Пользователю нужно дать понять, что операцию нужно повторить чуть позже.'
    }
  },
  dataError: {
    textTitle: {
      value: 'Не удалось получить данные',
      description: 'Не загрузилась таблица со списком сущностей или пользователь запросил данные, а результат не можем показать.'
    },
    text: {
      value: 'Обновите страницу. Если проблема сохранится, обратитесь в поддержку.',
      description: 'Просим обновить страницу и направляем в поддержку.'
    }
  },
  notFound: {
    textTitle: {
      value: 'Ничего не найдено',
      description: 'По поисковому запросу и фильтрам ничего не нашлось.'
    },
    textSearch: {
      value: 'Попробуйте изменить запрос',
      description: 'Если это результат только поиска. Просим выбрать другие значения для запроса.'
    },
    textSearchFilter: {
      value: 'Попробуйте изменить запрос или выбрать другие фильтры',
      description: 'Если это результат поиска и выставленных фильтров. Просим выбрать другие значения или фильтры.'
    }
  }
};